import { RegistrationFormData } from './registrationFormData';

export enum ActionType {
  UpdateFormData,
  ClearForm,
}

export interface RegistrationSubmitForm {
  type: ActionType.UpdateFormData;
  payload: RegistrationFormData;
}

export interface RegistrationClearForm {
  type: ActionType.ClearForm;
}

export type RegistrationFormActions = RegistrationSubmitForm | RegistrationClearForm;
